import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../../config/config";
import { getApiCall } from "../../services/apiHelper";
import { InvBudgetYearParams } from "../../types/assetplanid";

export interface AbfPortfolioStatus {
  investmentId: string;
  budgetYear: number;
  userName: string;
  dataType: string;
  yardiLastModifiedTimeStamp: Date;
  status: string;
}

interface AbfStatusState {
  data: AbfPortfolioStatus[];
  error: string;
  loading: boolean;
}

const initialState: AbfStatusState = {
  data: [],
  error: "",
  loading: false,
};

export const getAbfStatusLogs = createAsyncThunk(
  "getAbfStatusLogs",
  async (payload: InvBudgetYearParams) => {
    try {
      const response = await getApiCall<AbfPortfolioStatus[]>(
        `${baseUrl}abf/PorfolioAbfStatus?portfolioId=${payload.investmentId}&budgetYear=${payload.budgetYear}`
      );
      return response;
    } catch (error: any) {
      console.error("Error in ABF status request:", error);
      throw error;
    }
  }
);

const abfStatusSlice = createSlice({
  name: "abfStatus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAbfStatusLogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getAbfStatusLogs.fulfilled,
        (state, action: PayloadAction<AbfPortfolioStatus[]>) => {
          state.loading = false;
          state.data = action.payload;
        }
      )
      .addCase(getAbfStatusLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
  },
});

export default abfStatusSlice.reducer;